import { mapGetters, mapMutations, mapActions } from "vuex";

import Loader from "../components/Loader";
import SearchBox from "../components/SearchBox";
import SearchFilters from "../components/SearchFilters";
import SearchPagination from "../components/SearchPagination";
import SearchResultDocument from "../components/SearchResultDocument";
import VueScrollTo  from 'vue-scrollto';

export default {
  components: {
    Loader,
    SearchBox,
    SearchFilters,
    SearchPagination,
    SearchResultDocument,
  },
  computed: {
    ...mapGetters([
      "loaded",
      "searchQuery",
      "results",
      "settings",
      "selectedPageIndex",
    ]),
  },
	methods: {
    ...mapMutations(["setInlineSettings", "setPageIndex"]),
    ...mapActions(["setInitialValues", "executeSearch"]),
    submitSearch() {
      // sets the search text
      this.resetPageIndex();
      //this.changeOnlyOneParam("searchtext", this.searchQuery.searchTerm); 07.22.2024
      this.changeOnlyOneParam("searchtext", this.searchQuery.searchTerm.toUpperCase().replace("3C",""));
      this.executeSearch();
    },
    submitAlphaFilter() {
      // sets the search text
      this.resetPageIndex();
      this.changeOnlyOneParam("a", this.searchQuery.alphaFilter);
      this.executeSearch();
    },
    submitPage() {
      // sets the page from pagination

      // Scroll to top 
      VueScrollTo.scrollTo(".section-header__heading");
      
      this.changeOnlyOneParam("p", this.searchQuery.currentPage);
      this.executeSearch();
    },
    submitFilters(data) {
      // sets the filters
      this.resetPageIndex();
      this.changeOnlyOneParam("c", data);
      this.executeSearch();
    },
    resetPageIndex() {
      this.setPageIndex(0);
      //this.changeOnlyOneParam("p", this.searchQuery.searchTerm); 07.22.2024
	  this.changeOnlyOneParam("p", this.searchQuery.searchTerm.toUpperCase().replace("3C","")); 
    },
    changeOnlyOneParam(paramName, changeTo) {
      var params = JSON.parse(JSON.stringify(this.$route.query));
      params[paramName] = changeTo;

      this.$router
        .replace({
          query: params,
        })
        .catch(() => {});
    },
		initialize() {
			const inlineSettings = {
				shouldHeaderBeShown:
					!this.$root.hideQueryTextbox || this.$root.hideQueryTextbox === "false",
				shouldFiltersBeShown:
					!this.$root.hideFilters || this.$root.hideFilters === "false",
        showContentType: this.$root.showContentType ? this.$root.showContentType === "true" ? true : false : false,
				...(this.$root.pageSize && { pageSize: this.$root.pageSize }),
				...(this.$root.searchIndex && { searchIndex: this.$root.searchIndex }),
				...(this.$root.searchUrl && { searchUrl: this.$root.searchUrl }),
				...(this.$root.headerText && { headerText: this.$root.headerText }),
				...(this.$root.searchPlaceholder && {
					searchPlaceholder: this.$root.searchPlaceholder,
				}),
				...(this.$root.searchButtonText && {
					searchButtonText: this.$root.searchButtonText,
				}),
				...(this.$root.filterText && { filterText: this.$root.filterText }),
				...(this.$root.filterButtonText && {
					filterButtonText: this.$root.filterButtonText,
				}),
				...(this.$root.filterButtonText && {
					filterButtonText: this.$root.filterButtonText,
				}),
			};
			this.setInlineSettings(inlineSettings);
			this.setInitialValues(this.$route);
			this.executeSearch();
		}
	}
}